import {Component, OnInit} from '@angular/core';
import {AppSettings} from '../models/AppSettings';
import {AppMenu} from '../models/AppMenu';
import {UserService} from '../service/user.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-tws-footer',
    templateUrl: './tws-footer.component.html',
    styleUrls: ['./tws-footer.component.css']
})
export class TwsFooterComponent implements OnInit {

    constructor(private service: UserService, private router: Router) {}
    title = 'app works!';
    subscription: boolean = false;


    ngOnInit() {
        this.subscription = this.service.isLoggedIn();
        this.service.getLoginEvent().subscribe(item => {
            this.subscription = item;
        });
    }
    
    get sezione(){
        return AppSettings.sezione;
    }


}



// WEBPACK FOOTER //
// ./src/app/tws-footer/tws-footer.component.ts